module.exports = __webpack_public_path__ + "media/img/event/sbt_header-4ab4c4fc810a2d342bfd8ed557518725.png";